//@flow

type DeviceSize = {
  mobile: number,
  desktop: number,
}

const HeaderPaddingTop: DeviceSize = {mobile: 30, desktop:30};
const HeaderPaddingTopLandscape: DeviceSize = {mobile: 14, desktop:30};
const SidebarWidth: DeviceSize = {mobile: 0, desktop:416};
const SidebarHeight: DeviceSize = {mobile: 377, desktop:0};
const ButtonSizeL: DeviceSize = {mobile: 36, desktop:48};
const ButtonSizeM: DeviceSize = {mobile: 27, desktop:36};
const ButtonSizeS: DeviceSize = {mobile: 18, desktop:24};
const ConfiguratorBottom: DeviceSize = {mobile: 50, desktop:50};
const ShowroomMode = {NONE: '', CLOSING: 'closing', EXTERIOR: 'exterior', INTERIOR: 'interior'};
const Defaults = {transitionDuration: 0.25};
const MODE = {
  NONE: -1,
  EXTERIOR: 0,
  INTERIOR: 1,
};
const PreloadAssets = ['./icons/btn_exterior_bg.svg', './icons/btn_exterior_color.svg', './icons/btn_exterior_door.svg', './icons/btn_exterior_info.svg', './icons/btn_exterior_lamp.svg', './icons/btn_exterior_wheel.svg'];

export {HeaderPaddingTop, HeaderPaddingTopLandscape, SidebarWidth, SidebarHeight, ButtonSizeL, ButtonSizeM, ButtonSizeS, ConfiguratorBottom, ShowroomMode, Defaults, MODE, PreloadAssets};
